import institutionAPI from 'services/institutionAPI'

type Params = {
  unifiedPersonId: string
}

export default async function getUnifiedPersonOnCustomForm({ unifiedPersonId }: Params) {
  const response = await institutionAPI({
    method: 'GET',
    url: `/citizen-portal/service/unified-person/${unifiedPersonId}`,
  })

  return response
}
